import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "../../../components/grid";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO } from "../../../utils/const/estilos-const";
import ModalConfirmar from "../../../components/modal-confirmar";
import "../../../style/style-cargando.css";
import {
  INT_TIPO_USUARIO_ADMINISTRADOR_WEB,
} from "../../../utils/const/int-const";
// import { TRUE } from "../../../utils/const/bool-const";
import cargandoCard from "../../../components/cargando-card";
import SinAccesoCard from "../../../components/sin-acceso-card";
// import { Settings } from "feather-icons-react/build/IconComponents";
import { deshabilitarTipoVehiculo, obtenerListaTipoVehiculo } from "../../../api/tipo-vehiculo";
import { useTranslation } from "react-i18next";
import { STRING_COLOR_PRIMARIO, STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST, STRING_TIPO_USUARIO_CHECKLIST } from "../../../utils/const/string-const";
import { COLOR_AZUL_MAIN } from "../../../utils/const/colors-const";
import { obtenerPermisos } from "../../../api/api-permisos";
import { PAGE_ID } from "../../../utils/const/pages-const";

const idTipoUsuario = localStorage.getItem(STRING_TIPO_USUARIO_CHECKLIST);
const idSubTipoUsuarioWeb = localStorage.getItem(STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST);


export default function ListarTipoVehiculo() {
  const { t } = useTranslation();
  const headers = [
    { key: "acciones", title: t('column_acciones') },
    { key: "id", title: "ID", visible: false, },
    { key: "descripcion", title: t('column_descripcion'), visible: true, filter: true, editLabel: true, },
    { key: "nota", title: t('column_nota'), visible: true, filter: true, },
    { key: "fechaProceso", title: t('column_fecha_proceso'), visible: true, filter: true },
  ];
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [listaElementos, setListaElementos] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [colorMain, setColorMain] = useState(COLOR_AZUL_MAIN);

  const [btnNuevo, setBtnNuevo] = useState(false);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const colorBase = localStorage.getItem(STRING_COLOR_PRIMARIO);
      if (colorBase !== null) {
        setColorMain(colorBase);
      }
      let permiso = null;
      let lista = [];
      lista = await obtenerListaTipoVehiculo(false);
      if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        setBtnNuevo(true);
        setTieneAccesoAlModulo(true);
      }
      if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        const objEnviar = {
          idSubTipoUsuarioWeb: idSubTipoUsuarioWeb,
        };
        const permisos = await obtenerPermisos(objEnviar);
        if (permisos.error === false && Array.isArray(permisos.data) && permisos.data.length > 0) {
          permiso = permisos.data[0];
          const permisosInfo = JSON.parse(permisos.data[0].permisos);
          // console.log('permisosInfo');
          // console.log(permisosInfo);
          const permisosPage = permisosInfo.find(e => e.value === PAGE_ID.GESTIONAR_TIPO_VEHICULO);
          // console.log('permisosPage');
          // console.log(permisosPage);
          setTieneAccesoAlModulo(permisosPage.checked === true);
        }
      }
      agregarAccionesALista(lista, permiso);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const agregarAccionesALista = (lista, permiso) => {
    try {
      if (lista.length === 0) {
        setListaElementos(lista);
        return;
      }
      const objModificar = {
        label: t('btn_modificar'),
        color: "green",
        onClick: (param) => editarElementoSelected(param),
      };
      const objDeshabilitar = {
        label: t('btn_deshabilitar'),
        color: "red",
        onClick: (param) => cambiarEstado(param),
      };
      let btnModificar = false;
      let btnDeshabilitar = false;
      let btnNuevo = false;
      if (permiso !== null) {
        const parsePermisos = JSON.parse(permiso.permisos);
        const permisosTipoVehiculo = parsePermisos.find(e => e.value === PAGE_ID.GESTIONAR_TIPO_VEHICULO);
        if (permisosTipoVehiculo !== undefined) {
          const acciones = permisosTipoVehiculo.acciones;
          if (acciones !== undefined) {
            const modificar = acciones.find(e => e.value === 'btn_modificar');
            if (modificar !== undefined) {
              btnModificar = modificar.checked;
            }
            const deshabilitar = acciones.find(e => e.value === 'btn_deshabilitar');
            if (deshabilitar !== undefined) {
              btnDeshabilitar = deshabilitar.checked;
            }
            const nuevo = acciones.find(e => e.value === 'btn_nuevo');
            if (nuevo !== undefined) {
              btnNuevo = nuevo.checked;
            }
          }
        }
      }
      if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        setBtnNuevo(true);
      }
      if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        setBtnNuevo(btnNuevo);
      }
      for (let i = 0; i < lista.length; i++) {
        let acciones = [];
        if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
          acciones.push(objModificar);
          acciones.push(objDeshabilitar);
        }
        if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
          if (btnModificar === true) {
            acciones.push(objModificar);
          }
          if (btnDeshabilitar === true) {
            acciones.push(objDeshabilitar);
          }
        }
        lista[i].acciones = acciones;
      }
      setListaElementos(lista);

    } catch (err) {
      console.log('agregarAccionesALista err');
      console.log(err);
    }
  }

  const nextPage = (page, params) => {
    try {
      // history.push(`${page}`);
      // console.log('params');
      // console.log(params);
      if (params !== undefined && params !== null) {
        if (params.acciones !== undefined) {
          delete params.acciones;
        }
        // console.log('params sin acciones');
        // console.log(params);
        history.push({
          pathname: `${page}`,
          state: params
        });
      } else {
        history.push(`${page}`);
      }
    } catch (err) {
      console.log('nextPage err');
      console.log(err);
    }
  };

  const editarElementoSelected = (data) => {
    try {
      // console.log("editarElementoSelected");
      // console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      let obj = {};
      obj.titulo = t('titulo_modificar_tipo_vehiculo');
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      nextPage("tipo-vehiculo", obj);
    } catch (err) {
      console.log("editarElementoSelected err");
      console.log(err);
    }
  };

  const cambiarEstado = async (data) => {
    try {
      // console.log("cambiarEstado");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstado err");
      console.log(err);
    }
  };

  const handleNuevoClick = () => {
    // console.log("handleNuevoClick");
    let obj = {};
    let data = {};
    data.id = 0;
    data.descripcion = "";
    data.nota = "";
    obj.titulo = t('titulo_crear_tipo_vehiculo');
    obj.params = data;
    nextPage("tipo-vehiculo", obj);
  }

  const handleAtrasClick = () => {
    history.goBack();
  }

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  }

  const handleCancelModal = () => {
    setModalConfirmarDeshabilitarVisible(false);
  }

  const handleConfirmModal = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id > 0) {
      // console.log('crear correo');
      let deshabilitado = await deshabilitarTipoVehiculo(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (deshabilitado === true) {
        alert(t('alert_se_deshabilito_correctamente'));
        reset();
      }
      if (deshabilitado === false) {
        alert(t('alert_no_se_pudo_deshabilitar'));
      }
    }
  }

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return SinAccesoCard();
      }
      return (
        <div>
          <div
            style={{
              paddingTop: 16,
              paddingLeft: 16,
              paddingRight: 16,
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <label
              style={{
                paddingLeft: 10,
                fontWeight: 'bold',
              }}
            >
              {t('titulo_gestionar_tipo_vehiculo')}
            </label>
            <div className="flex justify-center">
              {btnNuevo === true && (
                <button
                  type="button"
                  className={ESTILO_BOTON_LISTAR_NUEVO}
                  onClick={handleNuevoClick}
                  style={{
                    backgroundColor: colorMain,
                  }}
                >
                  {t('btn_nuevo')}
                </button>
              )}
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                {t('btn_atras')}
              </button>
              {/* <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                <Settings />
              </button> */}
            </div>
          </div>
          <Grid rows={listaElementos} headers={headers} />
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={handleCancelModal}
            onConfirm={handleConfirmModal}
            message={t('alert_esta_seguro_de_deshabilitar_tipo_vehiculo')}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarTipoVehiculo render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
